import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import FormInput from '../../../../../library/form/components/FormInput';

const ProdIOTRetMatRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                    action={{ paramName: "variation2Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <FormROValue customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn90"  rowKey={rowKey} action={{ paramName: "qtyIssued" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyIssued" }} />
                </FormROValue>
                <li className="uiColumnCenter uiColumn130">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyReturned" }} />
                    <div style={{float:"left"}}> 
                        <FormInput formObject={formObject} className="uiWidth55 uiSpacerH5" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'qtyReturn1',
                            actionParam: {formulaSource: "RQ1", updateQty : "1", actionType:"updateQty"}}} />
                        <FormInput formObject={formObject} className="uiWidth55" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'qtyReturn2', 
                            actionParam: {formulaSource: "RQ2", updateQty : "1", actionType:"updateQty"}}} />
                    </div>
                </li>
                <li className="uiColumnCenter uiColumn130">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyConsumed" }} />
                    <div style={{float:"left"}}> 
                        <FormInput formObject={formObject} className="uiWidth55 uiSpacerH5" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'qtyConsume1',
                            actionParam: {formulaSource: "CQ1", updateQty : "1", actionType:"updateQty"}}} />
                        <FormInput formObject={formObject} className="uiWidth55" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'qtyConsume2', 
                            actionParam: {formulaSource: "CQ2", updateQty : "1", actionType:"updateQty"}}} />
                    </div>
                </li>
                <li className="uiColumnCenter uiColumn130">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyWastaged" }} />
                    <div style={{float:"left"}}> 
                        <FormInput formObject={formObject} className="uiWidth55 uiSpacerH5" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'qtyWastage1',
                            actionParam: {formulaSource: "WQ1", updateQty : "1", actionType:"updateQty"}}} />
                        <FormInput formObject={formObject} className="uiWidth55" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'qtyWastage2', 
                            actionParam: {formulaSource: "WQ2", updateQty : "1", actionType:"updateQty"}}} />
                    </div>
                </li>
            </ul>
        )
}

export default ProdIOTRetMatRow
